import { render, staticRenderFns } from "./OdobravanjePrijaveKvara.vue?vue&type=template&id=2cde3ccb&scoped=true&"
import script from "./OdobravanjePrijaveKvara.vue?vue&type=script&lang=ts&"
export * from "./OdobravanjePrijaveKvara.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cde3ccb",
  null
  
)

export default component.exports